import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionsRoutingModule } from './permissions-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Select2Module } from 'ng-select2-component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PermissionsComponent } from './permissions.component';


@NgModule({
  declarations: [
    PermissionsComponent
  ],
  imports: [
    CommonModule,
    PermissionsRoutingModule,
    SharedModule,
    Select2Module,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    MatSelectModule
  ]
})
export class PermissionsModule { }
